import axios from 'axios'

// Create a dedicated Axios instance
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://127.0.0.1:5001',
    headers: {
        'Content-Type': 'application/json'
    }
})

// Add a request interceptor to attach the JWT token
apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token') // The key where the token is stored
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

// Add a response interceptor to handle errors
apiClient.interceptors.response.use(
    (response) => {
    // If the request was successful, just return the response
        return response
    },
    (error) => {
    // Check if the error is a 403 Forbidden
        if (error.response && error.response.status === 403) {
            const detail = {
                title: 'Acceso Denegado',
                message: 'No tienes los permisos necesarios para realizar esta acción.',
                requiredPermission: null
            }

            if (error.response.data && error.response.data.requiredPermission) {
                detail.requiredPermission = error.response.data.requiredPermission
                detail.message = `No tienes el permiso requerido para esta acción: ${detail.requiredPermission}`
            }

            if (!error.config || !error.config.suppressGlobalErrorHandler) {
                window.dispatchEvent(new CustomEvent('apiError403', { detail }))
            }
        }

        return Promise.reject(error)
    }
)

export default apiClient
